"use strict";
// ==========================
// interfaces
// ==========================
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAppStorePageArgsValidator = exports.deleteAppStorePageArgsSchema = exports.updateAppStorePageArgsValidator = exports.updateAppStorePageArgsSchema = exports.publishAppArgsValidator = exports.publishAppArgsSchema = exports.createAppStoreItem = exports.getAppStoreImgUrl = exports.getAppStoreFolder = exports.getTmpImgUrl = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../common");
// ==========================
// utils
// ==========================
function getTmpImgUrl(imageId) {
    return "tmp/".concat(imageId);
}
exports.getTmpImgUrl = getTmpImgUrl;
function getAppStoreFolder(appId) {
    return "appStore/".concat(appId);
}
exports.getAppStoreFolder = getAppStoreFolder;
function getAppStoreImgUrl(_a) {
    var appId = _a.appId, imageId = _a.imageId;
    // NOTE we save the PDF directly under "channels" folder
    // because this makes it easier to delete PDF.
    // This is useful because the PDF is already uploaded before channel creation
    return "appStore/".concat(appId, "/").concat(imageId);
}
exports.getAppStoreImgUrl = getAppStoreImgUrl;
function createAppStoreItem(_a) {
    var publisher = _a.publisher, iconUrl = _a.iconUrl, title = _a.title, subTitle = _a.subTitle, description = _a.description, imageIds = _a.imageIds;
    return {
        details: {
            title: title,
            subTitle: subTitle,
            description: description,
            imageIds: imageIds,
            publisher: {
                name: publisher.name
            },
            iconUrl: iconUrl
        },
        // filter
        publisherId: publisher.id,
        publishedAt: Date.now(),
    };
}
exports.createAppStoreItem = createAppStoreItem;
// ==========================
// args
// ==========================
exports.publishAppArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
    title: suretype_1.v.string().minLength(1).maxLength(30).required(),
    subTitle: suretype_1.v.string().minLength(1).maxLength(200).required(),
    description: suretype_1.v.string().minLength(1).maxLength(1000).required(),
    imageIds: suretype_1.v.array(common_1.idSchema).maxItems(5).minItems(1).required(),
});
exports.publishAppArgsValidator = (0, suretype_1.compile)(exports.publishAppArgsSchema);
exports.updateAppStorePageArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
    title: suretype_1.v.string().minLength(1).maxLength(30).required(),
    subTitle: suretype_1.v.string().minLength(1).maxLength(200).required(),
    description: suretype_1.v.string().minLength(1).maxLength(1000).required(),
    imageIdsDelete: suretype_1.v.array(common_1.idSchema).maxItems(5).required(),
    imageIdsAdd: suretype_1.v.array(common_1.idSchema).maxItems(5).required(),
});
exports.updateAppStorePageArgsValidator = (0, suretype_1.compile)(exports.updateAppStorePageArgsSchema);
exports.deleteAppStorePageArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
});
exports.deleteAppStorePageArgsValidator = (0, suretype_1.compile)(exports.deleteAppStorePageArgsSchema);
